export default __webpack_public_path__ + "static/media/amm.9e2ed80c.svg";